/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Main/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import Details from './Details/index'
import Notes from './Notes/index'
import React from 'react'
import ReferralsSection from './ReferralsSection/index'
import Treatments from './Treatments/index'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaButtonText from 'DesignSystem/TysiaButton/TysiaButtonText/index'
import TysiaCard from 'DesignSystem/TysiaCard/index'
import TysiaCardContent from 'DesignSystem/TysiaCard/TysiaCardContent/index'
import TysiaCardHeader from 'DesignSystem/TysiaCard/TysiaCardHeader/index'
import TysiaHeading from 'DesignSystem/TysiaHeading/index'
import Tysiav2Notes from 'DesignSystem/Svgs/Tysiav2Notes/index'
import Tysiav2Patients from 'DesignSystem/Svgs/Tysiav2Patients/index'
import Tysiav2Referred from 'DesignSystem/Svgs/Tysiav2Referred/index'
import Tysiav2Treatment from 'DesignSystem/Svgs/Tysiav2Treatment/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Main({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Profile/Content/Main"
  
}) {
  let flow = fromFlow.useFlow()
  let setFlowTo = fromFlow.useSetFlowTo(viewPath)
let dtColorsNeutral300 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.300'
        })
let dtSpaceLs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.ls'
        })
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let dtColorsNeutral200 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.200'
        })
let dtSpaceMs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.ms'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
  return (<React.Fragment
>
<TysiaCard
  viewPath={`${viewPath}/TysiaCard`}
 size="xlarge"
 flexGrow={1}
 flexShrink={1}
 flexBasis="100%"
 borderColor={dtColorsNeutral300}
>
{childProps => (
<React.Fragment>
<TysiaCardHeader
{...childProps}
  viewPath={`${viewPath}/TysiaCardHeader`}
 paddingTop={dtSpaceLs}
 paddingBottom={dtSpaceLs}
 paddingLeft={dtSpaceS}
 paddingRight={dtSpaceS}
 borderBottomColor={dtColorsNeutral200}
 borderBottomWidth={1}
>
{childProps => (
<React.Fragment>
<Tysiav2Patients
{...childProps}
  viewPath={`${viewPath}/Tysiav2Patients`}
 height={18}
 marginRight={dtSpaceMs}
 fill2="#3E87CA"
/>
<TysiaHeading
{...childProps}
  viewPath={`${viewPath}/TysiaHeading`}
 level="h4"
 text="Patient Details"
/>
</React.Fragment>
)}
</TysiaCardHeader>
<TysiaCardContent
{...childProps}
  viewPath={`${viewPath}/TysiaCardContent`}
 borderTopLeftRadius={0}
 borderTopRightRadius={0}
 paddingBottom={dtSpaceS}
 paddingLeft={dtSpaceS}
 paddingRight={dtSpaceS}
 paddingTop={dtSpaceS}
 flexDirection="column"
>
{childProps => (
<Details
{...childProps}
  viewPath={`${viewPath}/Details`}
/>
)}
</TysiaCardContent>
</React.Fragment>
)}
</TysiaCard>
<TysiaCard
  viewPath={`${viewPath}/TysiaCard`}
 size="xlarge"
 flexGrow={1}
 flexShrink={1}
 flexBasis="100%"
 borderColor={dtColorsNeutral300}
>
{childProps => (
<React.Fragment>
<TysiaCardHeader
{...childProps}
  viewPath={`${viewPath}/TysiaCardHeader`}
 paddingTop={dtSpaceLs}
 paddingBottom={dtSpaceLs}
 paddingLeft={dtSpaceS}
 paddingRight={dtSpaceS}
 borderBottomColor={dtColorsNeutral200}
 borderBottomWidth={1}
>
{childProps => (
<div
  data-testid="Main.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<div
  data-testid="Main.Horizontal:1"
  data-view-path={viewPath}
 style={{'--g-1-awql': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Horizontal1}`}
>
<Tysiav2Referred
  viewPath={`${viewPath}/Tysiav2Referred`}
/>
<TysiaHeading
  viewPath={`${viewPath}/TysiaHeading`}
 level="h4"
 text="Referred by"
/>
</div>
<TysiaButton
  viewPath={`${viewPath}/TysiaButton`}
 size="small"
 type="primary"
 onClick={() => setFlowTo(fromFlow.normalizePath(viewPath, 'ReferralsSection/Add/Content'))}
 isSelected={flow.has(fromFlow.normalizePath(viewPath, 'ReferralsSection/Add/Content'))}
>
{childProps => (
<TysiaButtonText
{...childProps}
  viewPath={`${viewPath}/TysiaButtonText`}
 text="Add new"
/>
)}
</TysiaButton>
</div>
)}
</TysiaCardHeader>
<TysiaCardContent
{...childProps}
  viewPath={`${viewPath}/TysiaCardContent`}
 borderTopLeftRadius={0}
 borderTopRightRadius={0}
 paddingBottom={dtSpaceS}
 paddingLeft={dtSpaceS}
 paddingRight={dtSpaceS}
 paddingTop={dtSpaceS}
 flexDirection="column"
>
{childProps => (
<ReferralsSection
{...childProps}
  viewPath={`${viewPath}/ReferralsSection`}
/>
)}
</TysiaCardContent>
</React.Fragment>
)}
</TysiaCard>
<TysiaCard
  viewPath={`${viewPath}/TysiaCard`}
 size="xlarge"
 flexGrow={1}
 flexShrink={1}
 flexBasis="100%"
 borderColor={dtColorsNeutral300}
>
{childProps => (
<React.Fragment>
<TysiaCardHeader
{...childProps}
  viewPath={`${viewPath}/TysiaCardHeader`}
 paddingTop={dtSpaceLs}
 paddingBottom={dtSpaceLs}
 paddingLeft={dtSpaceS}
 paddingRight={dtSpaceS}
 borderBottomColor={dtColorsNeutral200}
 borderBottomWidth={1}
>
{childProps => (
<div
  data-testid="Main.Horizontal:2"
  data-view-path={viewPath}
 style={{'--g-1-awql': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Horizontal2}`}
>
<Tysiav2Treatment
  viewPath={`${viewPath}/Tysiav2Treatment`}
/>
<TysiaHeading
  viewPath={`${viewPath}/TysiaHeading`}
 level="h4"
 text="Treatments"
/>
</div>
)}
</TysiaCardHeader>
<TysiaCardContent
{...childProps}
  viewPath={`${viewPath}/TysiaCardContent`}
 borderTopLeftRadius={0}
 borderTopRightRadius={0}
 paddingBottom={dtSpaceS}
 paddingLeft={dtSpaceS}
 paddingRight={dtSpaceS}
 paddingTop={dtSpaceS}
 flexDirection="column"
>
{childProps => (
<Treatments
{...childProps}
  viewPath={`${viewPath}/Treatments`}
/>
)}
</TysiaCardContent>
</React.Fragment>
)}
</TysiaCard>
<TysiaCard
  viewPath={`${viewPath}/TysiaCard`}
 size="xlarge"
 flexGrow={1}
 flexShrink={1}
 flexBasis="100%"
 borderColor={dtColorsNeutral300}
>
{childProps => (
<React.Fragment>
<TysiaCardHeader
{...childProps}
  viewPath={`${viewPath}/TysiaCardHeader`}
 paddingTop={dtSpaceLs}
 paddingBottom={dtSpaceLs}
 paddingLeft={dtSpaceS}
 paddingRight={dtSpaceS}
 borderBottomColor={dtColorsNeutral200}
 borderBottomWidth={1}
>
{childProps => (
<div
  data-testid="Main.Horizontal:3"
  data-view-path={viewPath}
 style={{'--g-1-awql': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Horizontal3}`}
>
<Tysiav2Notes
  viewPath={`${viewPath}/Tysiav2Notes`}
/>
<TysiaHeading
  viewPath={`${viewPath}/TysiaHeading`}
 level="h4"
 text="Patient notes"
/>
</div>
)}
</TysiaCardHeader>
<TysiaCardContent
{...childProps}
  viewPath={`${viewPath}/TysiaCardContent`}
 borderTopLeftRadius={0}
 borderTopRightRadius={0}
 paddingBottom={dtSpaceS}
 paddingLeft={dtSpaceS}
 paddingRight={dtSpaceS}
 paddingTop={dtSpaceS}
 flexDirection="column"
>
{childProps => (
<Notes
{...childProps}
  viewPath={`${viewPath}/Notes`}
/>
)}
</TysiaCardContent>
</React.Fragment>
)}
</TysiaCard>
{children}
</React.Fragment>)
}